import { Card, TextSkeleton } from "@clipboard-health/ui-components";
import { CardContent } from "@mui/material";

export function LicenseCardSkeleton() {
  return (
    <Card outlined variant="quaternary" sx={{ flexShrink: 0, minHeight: "11rem" }}>
      <CardContent>
        <TextSkeleton variant="body1" width="50%" />
      </CardContent>
    </Card>
  );
}
